import * as React from "react";
import { fa } from "typed-font-awesome";

import * as comps from "../items/index";
import { MenuItem, SubmenuItem } from "app/features/componentes/menu/index";

export const catalogos: SubmenuItem[] = [
    {
        titulo: "",
        items: [
            {
                titulo: "Clientes",
                icon: fa("handshake-o"),
                route: "Cliente",
                visible: x => x.Catalogos.Cliente.VerMenu,
                render: () => <comps.ClienteCatalogo />
            }, {
                titulo: "Usuarios",
                icon: fa("user"),
                route: "Usuario",
                visible: x => x.Catalogos.Usuario.VerMenu,
                render: (props) => <comps.UsuarioCatalogo {...props} />
            }, {
                titulo: "Usuarios API",
                icon: fa("user"),
                route: "UsuarioApi",
                visible: x => x.Catalogos.UsuarioApi.VerMenu,
                render: (props) => <comps.UsuarioApiCatalogo {...props} />
            }, {
                titulo: "Roles",
                icon: fa("user-circle-o"),
                route: "Rol",
                visible: x => x.Catalogos.Rol.VerMenu,
                render: (props) => <comps.RolCatalogo {...props} />
            }, {
                titulo: "Sucursales",
                icon: fa("building-o"),
                route: "Sucursal",
                visible: x => x.Catalogos.Sucursal.VerMenu,
                render: (props) => <comps.SucursalCatalogo {...props} />
            }, {
                titulo: "Cajas",
                icon: fa("archive"),
                route: "Caja",
                visible: x => x.Catalogos.Caja.VerMenu,
                render: (props) => <comps.CajaCatalogo {...props} />
            }, {
                titulo: "Tarifas / convenios",
                icon: fa("credit-card-alt"),
                route: "Tarifa",
                visible: x => x.Catalogos.Tarifa.VerMenu,
                render: (props) => <comps.TarifaCatalogo {...props} />
            }, {
                titulo: "Matrices de tarifas",
                icon: fa("usd"),
                route: "MatrizTarifa",
                visible: x => x.Catalogos.MatrizTarifa.VerMenu,
                render: (props) => <comps.MatrizTarifaCatalogo {...props} />
            }, {
                titulo: "Tarifas de guías prepagadas",
                icon: fa("credit-card"),
                route: "TarifaPP",
                visible: x => x.Catalogos.TarifaPP.VerMenu,
                render: props => <comps.TarifaPPCatalogo {... props} />
            }, {
                titulo: "Contenidos de paquete",
                icon: fa("cube"),
                route: "ContenidoPaquete",
                visible: x => x.Catalogos.ContenidoPaquete.VerMenu,
                render: (props) => <comps.ContenidoPaqueteCatalogo {...props} />
            }, {
                titulo: "Contenidos de sobre",
                icon: fa("envelope-o"),
                route: "ContenidoSobre",
                visible: x => x.Catalogos.ContenidoSobre.VerMenu,
                render: (props) => <comps.ContenidoSobreCatalogo {...props} />
            }, {
                titulo: "Descripciones de paquete",
                icon: fa("cubes"),
                route: "DescripcionPaquete",
                visible: x => x.Catalogos.DescripcionPaquete.VerMenu,
                render: (props) => <comps.DescripcionPaqueteCatalogo {...props} />
            }, {
                titulo: "Requerimientos de acuse",
                icon: fa("check-circle"),
                route: "RequerimientoAcuse",
                visible: x => x.Catalogos.RequerimientoAcuse.VerMenu,
                render: (props) => <comps.RequerimientoAcuseCatalogo {...props} />
            }, {
                titulo: "Cajas de ruta",
                icon: fa("stop"),
                route: "CajaRuta",
                visible: x => x.Catalogos.CajaRuta.VerMenu,
                render: (props) => <comps.CajaRutaCatalogo {...props} />
            }, {
                titulo: "Segmentos",
                icon: fa("map-pin"),
                route: "Segmento",
                visible: x => x.Catalogos.Segmento.VerMenu,
                render: (props) => <comps.SegmentoCatalogo {...props} />
            }, {
                titulo: "Rutas",
                icon: fa("map-o"),
                route: "Ruta",
                visible: x => x.Catalogos.Ruta.VerMenu,
                render: (props) => <comps.RutaCatalogo {...props} />
            }, {
                titulo: "Camiones de ruta",
                icon: fa("bus"),
                route: "Camion",
                visible: x => x.Catalogos.Camion.VerMenu,
                render: (props) => <comps.CamionCatalogo {...props} />
            }, {
                titulo: "Choferes de ruta",
                icon: fa("users"),
                route: "ChoferRuta",
                visible: x => x.Catalogos.ChoferEAD.VerMenu,
                render: (props) => <comps.ChoferRutaCatalogo {...props} />
            }, {
                titulo: "Articulos",
                icon: fa("stack-exchange"),
                route: "Articulos",
                visible: x => x.Catalogos.Articulo.VerMenu,
                render: (props) => <comps.ArticuloCatalogo {...props} />
            }, {
                titulo: "Rutas de entrega a domicilio",
                icon: fa("location-arrow"),
                route: "RutasEAD",
                visible: x => x.Catalogos.RutaEAD.VerMenu,
                render: (props) => <comps.RutaEntregaDomicilioCatalogo {...props} />
            }, {
                titulo: "Matriz de distancias",
                icon: fa("map-signs"),
                route: "MatrizDistancias",
                visible: x => x.Catalogos.MatrizDistancia.VerMenu,
                render: (props) => <comps.MatrizDistanciasCatalogo {...props} />
            }, {
                titulo: "Camiones de entrega a domicilio",
                icon: fa("truck"),
                route: "camionesEAD",
                visible: x => x.Catalogos.CamionEAD.VerMenu,
                render: (props) => <comps.CamionEADCatalogo {...props} />
            }, {
                titulo: "Vendedores",
                icon: fa("hand-lizard-o"),
                route: "vendedores",
                visible: x => x.Catalogos.Vendedor.VerMenu,
                render: (props) => <comps.VendedorCatalogo {...props} />
            }, {
                titulo: "Choferes EAD",
                icon: fa("user"),
                route: "choferEAD",
                visible: x => x.Catalogos.ChoferEAD.VerMenu,
                render: (props) => <comps.ChoferEADCatalogo {...props} />
            }, {
                titulo: "Cobradores",
                icon: fa("motorcycle"),
                route: "cobradores",
                visible: x => x.Catalogos.Cobradores.VerMenu,
                render: (props) => <comps.CobradorCatalogo {...props} />
            }, {
                titulo: "Bancos",
                icon: fa("bank"),
                route: "Banco",
                visible: x => x.Catalogos.Banco.VerMenu,
                render: (props) => <comps.BancoCatalogo {...props} />
            }, {
                titulo: "Matriz tiempos",
                icon: fa("clock-o"),
                route: "matricestiempos",
                visible: x => x.Catalogos.MatrizTiempo.VerMenu,
                render: (props) => <comps.MatrizTiemposCatalogo {...props} />
            }
        ]
    },

    {
        titulo: "Datos Direcciones",
        items: [
            {
                titulo: "Estados",
                icon: fa("map-signs"),
                route: "Estados",
                //visible: x => x.Catalogos.ZonaExtendida.VerMenu,
                render: (props) => <comps.DireccionEstadoCatalogo {...props} />
            },
            {
                titulo: "Colonias",
                icon: fa("map-signs"),
                route: "Colonias",
                //visible: x => x.Catalogos.ZonaExtendida.VerMenu,
                render: (props) => <comps.DireccionColoniaCatalogo {...props} />
            },
        ]
    },
    {
        titulo: "Zonas extendidas",
        items: [{
            titulo: "Tarifa de pago a proveedores de ZE",
            icon: fa("money"),
            route: "tarifapagochofer",
            visible: x => x.Catalogos.TarifaPagoChoferes.VerMenu,
            render: (props) => <comps.TarifaPagoChoferCatalogo {...props} />
        }, {
            titulo: "Zonas extendidas",
            icon: fa("exchange"),
            route: "zonaext",
            visible: x => x.Catalogos.ZonaExtendida.VerMenu,
            render: (props) => <comps.ZonaExtendidaCatalogo {...props} />
        }, {
            titulo: "Proveedor ZE",
            icon: fa("user-circle"),
            route: "usuariosze",
            visible: x => x.Catalogos.ZonaExtendida.VerMenu,
            render: (props) => <comps.UsuarioZECatalogo {...props} />
        }, {
            titulo: "Tarifa precio ZE",
            icon: fa("euro"),
            route: "tarifasprecio",
            visible: x => x.Catalogos.ZonaExtendida.VerMenu,
            render: (props) => <comps.TarifaPrecioZECatalogo {...props} />
        }/*, {

            titulo: "Chofer ZE",
            icon: fa("user-circle-o"),
            route: "choferze",
            visible: x=> x.Catalogos.ZonaExtendida.VerMenu,
            render: (props) => <comps.ChoferZECatalogo {...props} />
        }*/
        ]
    }
];



// WEBPACK FOOTER //
// ./app/features/general/catalogos/menu/catalogos.tsx